import { RootState } from "../../reducers";
import { SelectorTitle, SelectorName, SelectorInputOption } from "../../styles/SelectorStyles";
import { useSelector, useDispatch } from "react-redux";
import { getCompetitionName } from "../../utils";
import { sendAnalyticsEvent } from "../../utils/sendAnalyticMessages";

const filterSortOrder = ["Moneyline", "Spread", "Total"];

function MarketSelector(): JSX.Element {
  const filterStore = useSelector((state: RootState) => state.filter);
  const dispatch = useDispatch();

  const teamMarkets = filterStore.configData.markets.sort((a, b) => filterSortOrder.indexOf(a.name) - filterSortOrder.indexOf(b.name));
  const playerMarkets = filterStore.configData.playerMarkets[getCompetitionName(filterStore)];

  const parentURL = document.referrer
    ? document.referrer
    : window.location.ancestorOrigins?.[0];

  const handleOnChange = (type: string) => {
    dispatch({
      type: "SET_MARKET_FILTER",
      payload: type,
    });
    dispatch({
      type: "SET_SELECTED_FILTER",
      payload: '',
    });
    sendAnalyticsEvent(
      {
        event: "smart_picks_market_select",
        selection: type,
      },
      parentURL
    );
  }

  return (
    <div>
      <SelectorTitle>
        Team Markets
      </SelectorTitle>
      {teamMarkets.map((i) => (
        <SelectorInputOption key={i.type} onClick={() => {
          handleOnChange(i.type)
        }}>
          <SelectorName>{i.name}</SelectorName>
          <div>
            <input
              readOnly
              type="radio"
              id={i.type}
              name="market"
              value={i.type}
              checked={filterStore.market === i.type}
            />
          </div>
        </SelectorInputOption>
      ))
      }
      {
        playerMarkets.length > 0 &&
        <SelectorTitle>
          Player Props
        </SelectorTitle>
      }
      {
        playerMarkets.map((i) => (
          <SelectorInputOption key={i.type} onClick={() => {
            handleOnChange(i.type)
          }}>
            <SelectorName>{i.name}</SelectorName>
            <div>
              <input
                readOnly
                type="radio"
                id={i.type}
                name="market"
                value={i.type}
                checked={filterStore.market === i.type}
              />
            </div>
          </SelectorInputOption>
        ))
      }
    </div>
  );
}

export default MarketSelector;
